export default __webpack_public_path__ + "static/media/Director_img.c414676a.jpg";